// extracted by mini-css-extract-plugin
export default {"appBar":"dashboardheader_appBar__z6iWG","toolBar":"dashboardheader_toolBar__MO1ES"};